import { CustomReport } from '../models/CustomReports';
import { request as __request } from '../core/request';
import { CancelablePromise } from '../core/CancelablePromise';

export class CustomReportsService {
  public static customReportsCreate(path: string, body: Record<string, any>): CancelablePromise<CustomReport> {
    return __request({
      method: 'POST',
      path,
      body,
    });
  }
}
